"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

/**
 * Hook that alerts clicks outside of the passed ref
 */
var useOutsideAlerter = function useOutsideAlerter(ref, callback) {
  (0, _react.useEffect)(function () {
    /**
     * Alert if clicked on outside of element
     */
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }; // Bind the event listener


    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

var _default = useOutsideAlerter;
exports["default"] = _default;